import { atomWithKey as atom } from "./atomWithKey";
import { ITrainScheduleResponse } from "../../Orchestrator/Types/Interface/ITrainScheduleResponse";

export const trainScheduleDataAtom = atom<ITrainScheduleResponse | null>({
  key: "trainScheduleDataAtom",
  default: null,
});